import {JSX} from "react";

import {Typography} from "@/shared/ui/data-display/typography";

import type {VideoTestimonialReview} from "../video-testimonials.types";

interface VideoTestimonialsReviewProps {
    review: VideoTestimonialReview;
}

export function VideoTestimonialsReview({review}: VideoTestimonialsReviewProps): JSX.Element {
    return (
        <div className="video-testimonials__review">
            <Typography as="div" size={{desktop: 18, mobile: 14}} weight={500} className="video-testimonials__review-author">
                {review.author}
            </Typography>
            <Typography as="div" size={{desktop: 18, mobile: 14}} weight={400} color="paragraph" className="video-testimonials__review-position">
                {review.position}
            </Typography>
            <Typography as="p" size={14} weight={500} color="paragraph" className="video-testimonials__review-text">
                {review.text}
            </Typography>
        </div>
    );
}
